var autoLoadDuration = 4;
var eventList = ["keydown", "mousemove", "wheel", "touchmove", "touchstart", "touchend"];
var delayedScriptsStarted = false;
var autoLoadTimeout = setTimeout(triggerScripts, autoLoadDuration * 1000);
eventList.forEach(function(event) {
    window.addEventListener(event, triggerScripts, { passive: true });
});
function triggerScripts() {
    if (delayedScriptsStarted) return;
    delayedScriptsStarted = true;
    clearTimeout(autoLoadTimeout);
    eventList.forEach(function(event) {
        window.removeEventListener(event, triggerScripts, { passive: true });
    });
    document.querySelectorAll("script[delay]").forEach(function(scriptTag) {
        scriptTag.async = false;
        scriptTag.setAttribute("src", scriptTag.getAttribute("delay"));
        scriptTag.removeAttribute("delay");
    });
}
